module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-reset-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('router-link', {
    staticClass: "sk-logo",
    attrs: {
      "to": "/login"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 3L28 9V18C28 23.5 22.8 28.3 16 30C9.2 28.3 4 23.5 4 18V9L16 3Z",
      "fill": "#F5841F",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3L28 9V18C28 23.5 22.8 28.3 16 30C9.2 28.3 4 23.5 4 18V9L16 3Z",
      "stroke": "#F5841F",
      "stroke-width": "1.5",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11 16l3.5 3.5L21 12",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "sk-logo-text"
  }, [_vm._v("SentryKit")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Verify email")]), _vm._v(" "), (_vm.working) ? _c('p', [_vm._v("Confirming your email address…")]) : (!_vm.token || !_vm.email) ? _c('p', [_vm._v("This link is missing required parameters.")]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "sk-success-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.working) ? _c('div', {
    staticClass: "sk-login-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in")])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d3edbc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/VerifyEmailPage.vue
// module id = 733
// module chunks = 2